import { CommonModule, Location } from "@angular/common";
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from "@angular/router";
import * as moment from "moment";
import { LocalizationModule } from "src/app/components/localization";
import { SafePipe } from "src/app/shared/pipes/safe.pipe";
import { TruncatePipe } from "src/app/shared/pipes/truncate.pipe";
import { EventsService } from "src/app/shared/constants/events.service";
import { Event } from "../../../shared/models/event.model";
import { MatTabsModule } from "@angular/material/tabs";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { Observable, map, of, Subscription } from "rxjs";
import { isIOS } from "../../../utils/detect-ios.function";
import { IconBrows } from "../../../../assets/icons/brows";
import { IconDirections } from "../../../../assets/icons/directions";
import { IconTriangleRight } from "../../../../assets/icons/triangle-right";
import { IconEnvelopeWhite } from "../../../../assets/icons/envelope-white";
import { SafeTypes } from "../../../shared/constants/safe-types.enum";
import {
  CarouselModule,
  OwlOptions,
  SlidesOutputData,
} from "ngx-owl-carousel-o";
import { DialogService } from "src/app/shared/services/dialog.service";
import { ImgSlideComponent } from "../img-slide/img-slide.component";
import { Select, Store } from "@ngxs/store";
import { UserState } from "../../../store/user/user.store";
import { User } from "../../../shared/models/user.model";
import { SignInSignUpComponent } from "../../../components/signin-signup/signin-signup.component";
import { AuthService } from "../../../shared/services/auth.service";
import { MatDialog } from "@angular/material/dialog";
import { LoaderService } from "../../../shared/services/loader.service";
import { filter } from "rxjs/operators";
import { NavigationService } from "../../../shared/services/navigation.service";
import { MatMenuModule } from "@angular/material/menu";
import { environment } from "../../../../environments/environment";
import { TranslocoService } from "@ngneat/transloco";
import { ToastrService } from "ngx-toastr";
import { isBefore } from "src/app/utils/membership-utils";
import { CallToPhoneDialogComponent } from "src/app/components/dialogs/call-phone-dialog/call-phone-dialog.component";
import { AffiliateService } from "../../../shared/services/affiliate.service";
import { SubEvent } from "../../../shared/models/sub-event.model";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf.mjs";
import { ThemeService } from "src/app/shared/constants/theme.service";
import { MembershipService } from "src/app/shared/services/membership.service";

(
  pdfjsLib as any
).GlobalWorkerOptions.workerSrc = `${document.baseURI}assets/pdfjs/pdf.worker.min.mjs`;

export enum MenuItemType {
  event = "event",
  pricing = "pricing",
  timetable = "timetable",
  checkInTimetable = "checkInTimetable",
  schedule = "schedule",
  competitors = "competitors",
  liveScore = "liveScore",
  medals = "medals",
  standings = "standings",
  flows = "flows",
  statistics = "statistics",
}

export enum RegistrationType {
  REGISTRATION_OFFICIAL = "official",
  REGISTRATION_COACH = "coach",
  REGISTRATION_JUDGE = "referee",
  REGISTRATION_VOLUNTEER = "volunteer",
}

interface ClubButton {
  label: string;
  value: string;
  classValue: string;
}

@Component({
  selector: "app-event",
  templateUrl: "./event.component.html",
  styleUrls: ["./event.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    SafePipe,
    LocalizationModule,
    RouterModule,
    MatTabsModule,
    ClipboardModule,
    CarouselModule,
    MatMenuModule,
  ],
  providers: [NavigationService],
})
export class EventComponent implements OnInit, OnDestroy {
  moment = moment;
  processedImages: any[] = [];
  currentLang: string = "en";
  isMultiSubEvents: boolean = false;
  isClubMembershipEvent = false;
  isMembershipLicensing = false;
  isPractiseEvent = false;
  isClubRegistrationRequested = false;
  clubsButtons: ClubButton[] = [];
  usaClubButtons: ClubButton[] = [
    { label: "CLUB", value: "a", classValue: "club-b" },
  ];
  regClubsButtons: ClubButton[] = [
    { label: "CLUB_A", value: "a", classValue: "club-a" },
    { label: "CLUB_B", value: "b", classValue: "club-b" },
    { label: "CLUB_C", value: "c", classValue: "club-c" },
  ];
  nonProfitClubsButtons: ClubButton[] = [
    { label: "TIER_ONE", value: "tier1", classValue: "club-a" },
    { label: "TIER_TWO", value: "tier2", classValue: "club-b" },
    { label: "TIER_THREE", value: "tier3", classValue: "club-c" },
  ];
  subEvents: SubEvent[] = [];
  isClubNonProfitEvent: boolean = false;
  nonAthleteMembershipUrl: string = "";
  isAthleteOrNonAthleteMembership: boolean = false;

  @ViewChildren("container") containerRefs!: QueryList<
    ElementRef<HTMLDivElement>
  >;
  @ViewChildren("canvas") canvasRefs!: QueryList<ElementRef<HTMLCanvasElement>>;

  private sub?: Subscription;

  private pdfDoc: any;
  private resizeObserver?: ResizeObserver;
  subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public eventsService: EventsService,
    private dialogService: DialogService,
    public location: Location,
    private dialog: MatDialog,
    public loaderService: LoaderService,
    public navigationService: NavigationService,
    private transloco: TranslocoService,
    private toastr: ToastrService,
    private store: Store,
    private affiliateService: AffiliateService,
    private themeService: ThemeService,
    private membershipService: MembershipService,
    private auth: AuthService
  ) {
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.router.navigateByUrl(event.url);
      });
  }

  @Select(UserState.isAdmin)
  isAdmin$!: Observable<boolean>;

  @Select(UserState.authUser)
  public authUser$!: Observable<User>;
  user: User | undefined;
  isAdmin = false;
  // isAssistedRegistrationAllowed: boolean = false;

  NO_REG_END_DATE = 3.14;
  public eventId!: number;
  public event!: Observable<Event>;
  public currentEvent!: Event | null;
  public currentSubEventId?: number;
  public clipBoardValue: string = "";
  public daysLeft: number = this.NO_REG_END_DATE;
  public IconeBrows = IconBrows;
  public IconDirections = IconDirections;
  public IconTriangleRight = IconTriangleRight;
  public IconEnvelopeWhite = IconEnvelopeWhite;
  public SafeTypes = SafeTypes;
  public selectedImage!: string;
  public isCopied = false;
  public breadcrumbs: string[] = [];
  public customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 600,
    navText: [
      "<div class='slide-prev'></div>",
      "<div class='slide-next'></div>",
    ],
    nav: true,
    center: true,
    autoplay: true,
    items: 1,
    autoWidth: true,
    margin: 8,
  };
  public images!: any[];
  public urls: string[] = [];
  previousUrl!: string;

  protected readonly MenuItemType = MenuItemType;
  protected readonly RegistrationType = RegistrationType;

  public activeMenuItem = MenuItemType.event;
  public menu: any;
  isAAUMembership: boolean = false;
  isUSAGRMembership: boolean = false;
  isJKFAthleteMembership: boolean = false;
  isAAUEventLicense: boolean = false;
  isUseEventLicenseFlyer: boolean = false;
  aauEventLicenseFlyerImageUrl = "";
  aauEventLicenseFlyerPdfUrl = "";
  aauEventLicenseFlyerPreviewUrl = ""; // Data URL from canvas or image URL
  pdfRenderedDimensions: any = null; // Store actual rendered dimensions

  ngOnInit(): void {
    this.themeService.applyAAUTheme();
    this.eventId = +this.route.snapshot.params["eventId"];

    this.affiliateService.init();
    this.transloco.langChanges$.subscribe((lang) => {
      const currentLang = lang.split("-")[0];
      this.currentLang = currentLang;
    });
    this.currentEvent = null;
    this.eventsService
      .getEvent(this.route.snapshot.params["eventId"])
      .subscribe(async (event: any) => {
        const config = event?.eventConfig;

        if (event.ratingSystems && event.ratingSystems.some((rs: any) => rs.id === 40)) {
          this.themeService.applyAAUTheme();
        } else {
          this.themeService.applyUventexTheme();
        }

        this.isAAUEventLicense = !!event.isAAUEventLicense || config.USAGR_EVENT_LICENSING;

        if (!event.eventPhotos.length && event.aauEventLicenseFlyerUrl) {
          this.isUseEventLicenseFlyer = true;
          this.aauEventLicenseFlyerPdfUrl = event.aauEventLicenseFlyerUrl;
          try {
            if (event.aauEventLicenseFlyerUrl.toLowerCase().indexOf('pdf') !== -1) {
              this.loadPdfFlyer(event.aauEventLicenseFlyerUrl);
            } else {
              this.aauEventLicenseFlyerImageUrl = event.aauEventLicenseFlyerUrl;
              this.aauEventLicenseFlyerPreviewUrl = event.aauEventLicenseFlyerUrl; // Use image URL directly
            }
          } catch (e) {
            console.error(e);
            console.error('Failed to load PDF: ' + event.aauEventLicenseFlyerUrl);
          }
        }

        //if (((config?.isUSAGRMembership || config?.isAAUMembership) && config.membershipType)) {
        if ((this.membershipService.isMembershipEvent(event) && config.membershipType)) {
          const { membershipType, nonAthleteMembershipEventId } = config;

          this.isUSAGRMembership = this.membershipService.isUSAGRMembership(event);
          this.isAAUMembership = this.membershipService.isAAUMembership(event);
          this.isJKFAthleteMembership = this.membershipService.isJKFAthleteMembership(event);

          if (this.isUSAGRMembership) {
            this.themeService.applyUventexTheme();
          } else if (this.isAAUMembership) {
          } else if (this.isJKFAthleteMembership) {
            this.themeService.applyUventexTheme();
          }

          switch (membershipType) {
            case "AAU_CLUB_MEMBERSHIP":
            case "AAU_CLUB_MEMBERSHIP_NON_PROFIT":
              this.isClubMembershipEvent = true;

              if (nonAthleteMembershipEventId) {
                this.nonAthleteMembershipUrl = `${environment.BASEURL}membership/${nonAthleteMembershipEventId}/new-person`;
              }

              if (this.isUSAGRMembership) {
                this.clubsButtons = this.usaClubButtons;
              } else {
                this.clubsButtons =
                  membershipType === "AAU_CLUB_MEMBERSHIP_NON_PROFIT"
                    ? ((this.isClubNonProfitEvent = true),
                      this.nonProfitClubsButtons)
                    : this.regClubsButtons;
              }

              break;

            case "AAU_EVENT_LICENSING":
              this.isMembershipLicensing = true;
              break;

            case "AAU_PRACTICE_EVENT":
              this.isPractiseEvent = true;
              break;

            case "AAU_ATHLETE_MEMBERSHIP":
            case "AAU_NON_ATHLETE_MEMBERSHIP":
              this.isAthleteOrNonAthleteMembership = true;
              break;
          }

          if (event.id === 334317) {
            this.isMembershipLicensing = true;
          }

          if (event.id === 337470) { // USAGR
            this.isMembershipLicensing = true;
          }

          if (event.id === 334318) {
            this.isPractiseEvent = true;
          }
        }

        if (event.subEvents && event.subEvents.length > 1) {
          this.isMultiSubEvents = true;
          this.subEvents = event.subEvents;
          this.subEvents = this.subEvents.sort((a, b) => a.name.localeCompare(b.name));
          await Promise.allSettled(this.subEvents.map(async (subEvent) => {
            subEvent.processedImage = await this.processImage({ url: subEvent.photoUrl });
          }));
          // for (let subEvent of this.subEvents) {
          //   subEvent.processedImage = await this.processImage({
          //     url: subEvent.photoUrl,
          //   });
          // }
        }
        // console.log("event", event);

        // const daysLeftMs = event.regEndDate - Date.now();
        // this.daysLeft = Math.ceil(daysLeftMs / (1000 * 3600 * 24));
        if (event.regEndDate) {
          const daysLeft = moment(event.regEndDate).diff(moment.now(), "days");
          this.daysLeft = daysLeft >= 0 ? daysLeft + 1 : 0;
        } else {
          this.daysLeft = this.NO_REG_END_DATE;
        }
        this.clipBoardValue = document.location.href;
        event.phoneArray = event.contactPhone
          ? event.contactPhone.split(",").map((phone: string) => phone.trim())
          : [];
        event.emailArray = event.contactEmail
          ? event.contactEmail.split(",").map((email: string) => email.trim())
          : [];

        this.currentEvent = event;
        this.event = of(event);
        for (const i of event.eventPhotos) {
          i.url = i.url.replace(/\+/g, "%2B");
        }
        this.images = event.eventPhotos
          .filter(
            (photo: any) =>
              photo.type === "EVENT_BANNER" ||
              photo.type === "EVENT_INFO" ||
              photo.type === "GALLERY"
          )
          .sort((a: any, b: any) => {
            if (a.type === "EVENT_BANNER" && b.type !== "EVENT_BANNER")
              return -1;
            if (b.type === "EVENT_BANNER" && a.type !== "EVENT_BANNER")
              return 1;
            return 0; // Maintain original order for other types
          });
        await this.processImages();
        this.initMenu();
      });

    window.scroll(0, 0);

    this.authUser$.subscribe((user) => {
      this.user = user;
      this.initMenu();

      if (user && user.eventAccount) {
        // // TODO redo detection of promoter/registrator based on eventpromoter roles (/api/events/334743/roles)
        // this.isAssistedRegistrationAllowed = user.eventAccount.accessLevel === "ADMIN" ||
        //   ((user.eventAccount.accessLevel === "PROMOTER" || user.eventAccount.accessLevel === "REGISTRATOR")
        //     && user.eventAccount.allowedEventIds && user.eventAccount.allowedEventIds.includes(+this.route.snapshot.params["eventId"]));
      }
    });

    this.isAdmin$.subscribe((isAdmin) => {
      this.isAdmin = isAdmin;
      this.initMenu();
    });
  }

  private loadPdfFlyer(url: string): void {
    (pdfjsLib as any).getDocument({ url }).promise.then(
      (doc: any) => {
        this.pdfDoc = doc;
        if (this.containerRefs.length) {
          this.initPdfRender();
        } else {
          this.sub = this.containerRefs.changes.subscribe(() => {
            this.initPdfRender();
            this.sub?.unsubscribe();
            this.sub = undefined;
          });
        }
      },
      (err: any) => {
        console.error(err);
        console.error('Failed to load PDF: ' + url);
      }
    );
  }

  get showMembershipPurchaseWarning(): boolean {
    if (!this.currentEvent || !this.currentEvent.eventEndDate) return false;
    const isTargetDate = typeof this.currentEvent.eventEndDate === 'string'
      ? this.currentEvent.eventEndDate.includes('2026-08-31')
      : moment(this.currentEvent.eventEndDate).format('YYYY-MM-DD') === '2026-08-31';

    return isTargetDate && this.isAAUMembership && (this.isAthleteOrNonAthleteMembership || this.isClubMembershipEvent || this.isMembershipLicensing || this.isPractiseEvent);
  }

  private async initPdfRender(): Promise<void> {
    await this.renderFirstPage();
    this.resizeObserver = new ResizeObserver(async () => {
      await this.renderFirstPage();
    });
    this.resizeObserver.observe(this.containerRefs.first?.nativeElement);
  }

  private async renderFirstPage() {
    if (!this.pdfDoc) return;
    const page = await this.pdfDoc.getPage(1);
    const container = this.containerRefs.first?.nativeElement;
    const canvas = this.canvasRefs.first.nativeElement;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const viewportAt1 = page.getViewport({ scale: 1 });
    const targetWidth = container.clientWidth || 1;
    const scale = targetWidth / viewportAt1.width;
    const dpr = window.devicePixelRatio || 1;
    const viewport = page.getViewport({ scale: scale });
    canvas.width = Math.floor(viewport.width * dpr);
    canvas.height = Math.floor(viewport.height * dpr);
    canvas.style.width = `${Math.floor(viewport.width)}px`;
    canvas.style.height = `${Math.floor(viewport.height)}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    await page.render({
      canvasContext: ctx,
      viewport,
    }).promise;

    // Convert canvas to data URL for use in enlarged view
    // Use actual canvas dimensions for proper aspect ratio
    const actualWidth = canvas.width / dpr;
    const actualHeight = canvas.height / dpr;

    // Create a high-resolution version for the enlarged view
    const enlargedScale = 2.5; // Increase scale for larger display
    const enlargedViewport = page.getViewport({ scale: viewportAt1.width * enlargedScale / viewportAt1.width });
    const tempCanvas = document.createElement('canvas');
    const tempCtx = tempCanvas.getContext('2d');
    if (tempCtx) {
      tempCanvas.width = Math.floor(enlargedViewport.width * 2);
      tempCanvas.height = Math.floor(enlargedViewport.height * 2);
      tempCtx.setTransform(2, 0, 0, 2, 0, 0);
      await page.render({
        canvasContext: tempCtx,
        viewport: enlargedViewport,
      }).promise;

      this.aauEventLicenseFlyerPreviewUrl = tempCanvas.toDataURL('image/png');

      // Store dimensions for the processed banner
      this.pdfRenderedDimensions = {
        width: enlargedViewport.width,
        height: enlargedViewport.height,
        aspectRatio: enlargedViewport.width / enlargedViewport.height
      };
    } else {
      // Fallback to current canvas if temp canvas fails
      this.aauEventLicenseFlyerPreviewUrl = canvas.toDataURL('image/png');
      this.pdfRenderedDimensions = {
        width: actualWidth,
        height: actualHeight,
        aspectRatio: actualWidth / actualHeight
      };
    }
  }

  ngOnDestroy() {
    for (const s of this.subscriptions) {
      s.unsubscribe();
    }
    this.themeService.applyUventexTheme();
    this.resizeObserver?.disconnect();
    this.sub?.unsubscribe();
  }

  async processImage(image: any) {
    try {
      return await this.loadImage(image);
    } catch (e) {
      // console.error("Error loading image:", image.url, e);
      return undefined;
    }
  }

  async processImages() {
    this.processedImages = [];

    const results = await Promise.allSettled(this.images.map(async (image) => {
      const processedImage = await this.loadImage(image);
      this.processedImages.push(processedImage);
    }));
    results
      .filter((r): r is PromiseRejectedResult => r.status === "rejected")
      .forEach((r) => {
        console.error("Failed to load image:", r.reason);
      });
    // for (const image of this.images) {
    //   try {
    //     const processedImage = await this.loadImage(image);
    //     this.processedImages.push(processedImage);
    //   } catch (error) {
    //     console.error("Error loading image:", image.url, error);
    //   }
    // }
  }

  loadImage(image: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = image.url;

      img.onload = () => {
        resolve({
          ...image,
          width: img.width,
          height: img.height,
          aspectRatio: img.width / img.height,
        });
      };

      img.onerror = (err) => {
        reject(err);
      };
    });
  }

  getAspectRatioClass(image: {
    width: number;
    height: number;
    aspectRatio: number;
  }): string {
    if (!image || !image.aspectRatio) {
      return "standard-image"; // Normal aspect ratios
    }
    if (image.aspectRatio < 0.45) {
      return "x-narrow-image";
    } else if (image.aspectRatio < 0.8) {
      return "narrow-image";
    } else if (image.aspectRatio > 1) {
      return "wide-image"; // Very wide images
    }
    return "standard-image"; // Normal aspect ratios
  }

  getReturnUrl() {
    let returnUrl = window.location.href;
    // if (returnUrl.indexOf(eventId) === -1) returnUrl += (returnUrl[returnUrl.length - 1] === "/" ? "" : "/") + eventId;
    returnUrl = encodeURIComponent(returnUrl).replaceAll("%2F", "___");

    return returnUrl;
  }

  initMenu() {
    const authToken = this.store.selectSnapshot(UserState.authToken);
    let returnUrl: string = this.getReturnUrl();
    const configItems = this.currentEvent?.eventConfig?.configItems;
    this.menu = this.eventsService.initMenu(
      this.currentEvent?.id,
      this.currentEvent?.superEventId,
      configItems,
      this.user,
      authToken,
      returnUrl,
      this.isAdmin,
      this.currentSubEventId,
      this.currentEvent?.isVisible,
      this.currentEvent
    );
  }

  preventNavigation(event: any, venue: any) {
    if (!venue?.maps?.length) {
      event.preventDefault(); // Prevents redirection
    }
  }

  getMapHref(l: any) {
    if (l?.maps.length)
      return isIOS()
        ? `https://maps.apple.com/?q=${l.zipCode || ""},${l.country.name || ""
        },${l.city || ""},${l.address || ""}`
        : `https://www.google.com/maps?q=${l.zipCode || ""},${l.country.name || ""
        },${l.city || ""},${l.address || ""}`;
    else return;
  }

  getLocation(venue: any): string {
    const address: string[] = [];
    let ad = venue?.address ? venue.address : "";
    let city = venue?.city ? venue.city : "";
    let state = venue?.state?.name ? venue.state.name : "";
    let province = venue?.province;
    if (province) {
      city = province;
    }
    let country = venue?.country?.name ? venue.country.name : "";
    address.push(ad.trim(), city.trim(), state.trim(), country.trim());
    return address.filter((a) => a).join(", ");
  }

  copyToClipBoard(text: any) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.toastr.success("Copied to clipboard");
      })
      .catch((err) => {
        console.error(err);
        this.toastr.error("Failed to copy to clipboard");
      });
  }

  copyLocationToClipBoard() {
    const location =
      (this.currentEvent?.venue.name ?? "") +
      " " +
      this.getLocation(this.currentEvent?.venue);
    this.copyToClipBoard(location);
  }

  changeImage(image: string) {
    this.selectedImage = image;
  }

  changedByNav(data: SlidesOutputData) {
    if (data.slides?.length) {
      this.selectedImage = data.slides[0].id;
    }
  }

  async openImg(params: { url: any; banners: any[] }) {
    // Don't open if URL is empty (PDF still rendering)
    if (!params.url) {
      console.warn('Preview URL not ready yet');
      return;
    }

    // Process banners if they don't have width/height/aspectRatio
    let processedBanners = params.banners;
    if (params.banners && params.banners.length > 0) {
      const firstBanner = params.banners[0];
      if (!firstBanner.width || !firstBanner.height || !firstBanner.aspectRatio) {
        // Need to process the banners
        processedBanners = [];
        for (const banner of params.banners) {
          // Check if this is the PDF preview (data URL)
          const isDataURL = banner.url && banner.url.startsWith('data:');

          if (isDataURL && this.pdfRenderedDimensions) {
            // For PDF preview with rendered dimensions, use the actual dimensions
            processedBanners.push({
              ...banner,
              ...this.pdfRenderedDimensions
            });
          } else if (banner.url && banner.url.toLowerCase().indexOf('pdf') !== -1) {
            // For direct PDF URLs (shouldn't happen now, but fallback)
            processedBanners.push({
              ...banner,
              width: 850,
              height: 1100,
              aspectRatio: 850 / 1100
            });
          } else {
            // For images, try to load and get actual dimensions
            try {
              const processed = await this.processImage(banner);
              if (processed) {
                processedBanners.push(processed);
              }
            } catch (e) {
              console.error('Error processing banner:', banner, e);
              // Fallback with default dimensions
              processedBanners.push({
                ...banner,
                width: 1000,
                height: 1000,
                aspectRatio: 1
              });
            }
          }
        }
      }
    }

    this.dialog.open(ImgSlideComponent, {
      data: {
        link: params.url,
        banners: processedBanners,
      },
      panelClass: 'custom-dialog-container',
      maxWidth: '100vw',
      maxHeight: '100vh',
      width: '90vw',
      height: '90vh',
    });
  }

  public onCopy(): void {
    this.isCopied = !this.isCopied;
    setTimeout(() => (this.isCopied = !this.isCopied), 2000);
  }

  handleRegisterAsOfficial(url: string) {
    this.subscriptions.push(
      this.authUser$.subscribe((user) => {
        if (user) {
          this.router.navigateByUrl(`registration-${url}/${this.eventId}`);
        } else {
          const dialogRef = this.auth.openSignIn({ signInAndClose: true });
        }
      }));
  }

  public handleAssistedRegistration(isOfficial: boolean) {
    if (this.user && this.user.eventAccount) {
      // registration is configured through leo
      if (this.currentEvent?.registrationUrl) {
        this.goToRegistrationDashboard();

      } else if (isOfficial) {
        const eventId = this.route.snapshot.paramMap.get("eventId");
        this.router.navigateByUrl("assisted-registration/" + eventId + "/officials");


      } else {
        const eventId = this.route.snapshot.paramMap.get("eventId");
        this.router.navigateByUrl("assisted-registration/" + eventId + "/athletes");
      }
    }
  }

  goToRegistrationDashboard() {
    window.location.href = this.getRegistrationDashboardLink();
  }

  getRegistrationDashboardLink() {
    const authToken = this.store.selectSnapshot(UserState.authToken);
    const token = authToken && authToken.token ? authToken.token : null;
    let returnUrl: string = this.getReturnUrl();
    return `${environment.EVENT_ADMIN_URL}GWTClient.html?&locale=${this.currentLang}#registration;id=${+this.route.snapshot.params["eventId"]};applicationMode=SPORTSHUB;sportsHubUrl=${returnUrl};token=${token}`;
  }

  public handleRegisterNow(subEventId?: number) {
    if (this.isMultiSubEvents) {
      if (subEventId) {
        const currentSubEvent =
          this.subEvents.find((se) => se.id === subEventId) || null;
        if (!currentSubEvent) return;
        this.currentSubEventId = subEventId;
      } else {
        this.currentSubEventId = this.subEvents[0].id;
      }
    }
    // todo redirect to event page

    if (this.currentEvent && this.currentEvent.isAAUEventLicense) {
      let isValid = false;
      try {
        new URL(this.currentEvent.registrationUrl);
        isValid = true;
      } catch (e) {
        isValid = false;
      }

      if (this.currentEvent.registrationUrl && isValid) {
        window.open(this.currentEvent.registrationUrl, "_blank");
      } else {
        window.open(
          "https://www.aausports.org/event-finder/?mi=5&sort-by=EventStartDate",
          "_blank"
        );
      }
      return;
    }

    this.authUser$.subscribe((user) => {
      if (user) {
        if (this.currentEvent?.isSportshubRegistrationAllowed === true) {
          if (
            this.isMultiSubEvents &&
            this.subEvents &&
            this.subEvents.length > 1
          ) {
            const eventId = this.route.snapshot.paramMap.get("eventId");
            this.router.navigate([
              `registration/${eventId}/subevent/${this.currentSubEventId}`,
            ]);
          } else {
            const eventId = this.route.snapshot.paramMap.get("eventId");
            this.router.navigateByUrl("registration/" + eventId);
          }
          return;
          // const eventId = this.route.snapshot.paramMap.get("eventId");
          // this.router.navigateByUrl("/event/" + eventId + "/registration");
          // return;
        }

        if (this.currentEvent?.registrationUrl) {
          // if (
          //   !this.currentEvent.eventConfig.isTrackAndField &&
          //   !this.currentEvent.eventConfig.isAAUMembership &&
          //   !this.currentEvent.eventConfig.isAAUKarate &&
          //   !this.currentEvent.eventConfig.isAAUIntegration
          // ) {
          //     console.log("here", this.eventId);

          //   // TODO: based on another logic redirect to default registration
          //   this.router.navigateByUrl(
          //     "/event/" + this.eventId + "/registration"
          //   );
          //   return;
          // }
          let token = localStorage.getItem("token");
          let returnUrl = encodeURIComponent(window.location.href).replaceAll(
            "%2F",
            "___"
          );

          let registrationUrl = this.currentEvent?.registrationUrl.replace(
            "{token}",
            token as string
          ) as string;

          if (
            this.currentEvent?.type === "CERTIFICATION" &&
            registrationUrl.includes("#eventRegistration")
          ) {
            registrationUrl = registrationUrl.replace(
              "#eventRegistration",
              "#certification"
            );
          }

          window.location.href = registrationUrl + `;sportsHubUrl=${returnUrl}`;
        } else if (
          this.isMultiSubEvents &&
          this.subEvents &&
          this.subEvents.length > 1
        ) {
          const eventId = this.route.snapshot.paramMap.get("eventId");
          this.router.navigate([
            `registration/${eventId}/subevent/${this.currentSubEventId}`,
          ]);
        } else {
          const eventId = this.route.snapshot.paramMap.get("eventId");
          this.router.navigateByUrl("registration/" + eventId);
        }
      } else {
        console.log('display membership login dialog');
        const dialogRef = this.auth.openSignIn({ signInAndClose: true });
      }
    });
  }

  handleBuyTickets() {
    // todo redirect to event page
    this.subscriptions.push(
      this.authUser$.subscribe((user) => {
        if (user) {
          if (!this.currentEvent) {
            return;
          }

          console.log(this.currentEvent.isSportshubRegistrationAllowed);
          if (this.currentEvent?.isSportshubRegistrationAllowed) {
            this.router.navigate(['/buy-tickets', this.eventId]);
            return;
          }

          let token = localStorage.getItem("token");
          let returnUrl = encodeURIComponent(window.location.href).replaceAll(
            "%2F",
            "___"
          );

          window.location.href =
            this.currentEvent?.registrationUrl.replace(
              "{token}",
              token as string
            ) + `;sportsHubUrl=${returnUrl}`;
          const url = `${environment.EVENT_PORTAL_URL}GWTClient.html?&locale=${this.currentLang}#tickets;id=${this.currentEvent.superEventId};applicationMode=SPORTSHUB;sportsHubUrl=${returnUrl};token=${token}`;
          window.location.href = url;
        } else {
          const dialogRef = this.auth.openSignIn({ signInAndClose: true });
        }
      }));
  }

  goToMembershipClub(club: string) {
    if (club === "tier2") {
      const dialogRef = this.dialog.open(CallToPhoneDialogComponent, {
        width: "370px",
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
        }
      });
      return;
    }

    localStorage.setItem("clubMembershipType", club);

    this.subscriptions.push(
      this.authUser$.subscribe((user) => {
        if (user) {
          this.router.navigateByUrl(
            `/membership/${this.currentEvent?.id}/clubs`
          );
        } else {
          const dialogRef = this.auth.openSignIn({ signInAndClose: true });
        }
      }));
  }

  onClubMembershipPurchaseClicked() {
    this.isClubRegistrationRequested = !this.isClubRegistrationRequested;
  }

  public checkRegistrationEnabled(event: any) {
//     // TODO:

    if (!event) {
      return false;
    }
    let eventRegEndDate = event?.regEndDate;

    if (event.isAAUEventLicense) {
      return true;
    }

    if (!eventRegEndDate || isBefore(eventRegEndDate)) {
      return false;
    }

    let result = false;

    if (event?.isRegistrationActive) {
      //console.log(`# Registration for event [${event.name}] is Active. Enabling ...`);
      result = true;
    }

    return result;
  }

  goBack() {
    this.location.back();
  }

  isAnyOfficialsRegistrationEnabled(): boolean {
    return (
      this.currentEvent?.isSportshubOfficialRegistrationAllowed &&
      (this.currentEvent?.eventConfig?.configItems?.REGISTRATION_OFFICIAL ||
        this.currentEvent?.eventConfig?.configItems?.REGISTRATION_COACH ||
        this.currentEvent?.eventConfig?.configItems?.REGISTRATION_JUDGE ||
        this.currentEvent?.eventConfig?.configItems?.REGISTRATION_VOLUNTEER)
    );
  }

  navigateToDownload(url: string) {
    if (url) {
      window.location.href = url;
    }
  }

  onBackClicked() {
    if (this.isAAUMembership) {
      this.router.navigateByUrl("/memberships");
      return;
    }

    this.navigationService.back();
  }

  goToMembershipEvent(
    eventType: "LICENSING" | "ATHLETE_NON_ATHLETE" | "PRACTICE"
  ) {
    this.subscriptions.push(
      this.authUser$.subscribe((user) => {
        if (user) {
          if (eventType === "LICENSING") {
            this.router.navigateByUrl(
              `membership/${this.route.snapshot.params["eventId"]}/event-licensing-dashboard`
            );
          } else if (eventType === "PRACTICE") {
            this.router.navigateByUrl(
              `membership/${this.route.snapshot.params["eventId"]}/practice-license-clubs`
            );
          } else {
            this.router.navigateByUrl(
              `/membership/${this.currentEvent?.id}/persons`
            );
          }
        } else {
          const dialogRef = this.auth.openSignIn({ signInAndClose: true });
        }
      }));
  }
}
